import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { WeeklySeries } from '@/api/worldCup';
import { AXIS_TICK, formatAxisTick } from '../ui/chartFormat';

type Props = {
  series: WeeklySeries;
  color?: string;
  height?: number;
};

export function WeeklyBars({ series, color = 'var(--ink)', height = 180 }: Props) {
  const data = series.series.map((p) => ({ name: `W${p.iso_week}`, value: p.value }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
        {/* Horizontal-only gridlines give the bars a readable scale without
            boxing the chart in. */}
        <CartesianGrid vertical={false} stroke="var(--line)" strokeOpacity={0.6} />
        <XAxis dataKey="name" tickLine={false} axisLine={{ stroke: 'var(--line)' }} tick={AXIS_TICK} />
        <YAxis tickLine={false} axisLine={false} width={40} allowDecimals={false} tick={AXIS_TICK} tickFormatter={formatAxisTick} />
        <Tooltip
          cursor={{ fill: 'var(--paper-2)' }}
          contentStyle={{ background: 'var(--paper)', border: '1.5px solid var(--line)', borderRadius: 6, fontSize: 12 }}
          labelStyle={{ color: 'var(--ink-soft)' }}
        />
        <Bar dataKey="value" fill={color} radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
